import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20008842"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "controls-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "switch-label" }, "单季", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "switch-label" }, "同比", -1))
const _hoisted_5 = {
  class: "chart-block",
  style: {"position":"relative"}
}
const _hoisted_6 = {
  id: "chartContainerzcfzb",
  style: {"height":"300px","margin-top":"24px","width":"100%"}
}
const _hoisted_7 = {
  key: 1,
  style: {"height":"300px","margin-top":"24px","width":"100%","display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_8 = {
  key: 0,
  class: "table-wrapper"
}
const _hoisted_9 = { class: "fixed-table-container" }
const _hoisted_10 = { class: "fixed-table" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "font-bold" }, "财务指标")
  ])
], -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "scroll-table-container" }
const _hoisted_15 = { class: "scroll-table" }
const _hoisted_16 = {
  key: 0,
  class: "yoy-header"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "value-cell" }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.spinning
    }, {
      default: _withCtx(() => [
        (_ctx.financialData.length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_a_radio_group, {
                  value: _ctx.activeReportType,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeReportType) = $event)),
                  "button-style": "solid",
                  onChange: _ctx.handleReportTypeChange
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportTypes, (item, i) => {
                      return (_openBlock(), _createBlock(_component_a_radio_button, {
                        key: 'rt' + i,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onChange"]),
                _createElementVNode("div", {
                  class: "single-quarter-switch",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleSingleQuarter && _ctx.toggleSingleQuarter(...args)))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["radio-button", { active: _ctx.reportCate === 2 }])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["radio-dot", { active: _ctx.reportCate === 2 }])
                    }, null, 2)
                  ], 2),
                  _hoisted_3
                ]),
                _createElementVNode("div", {
                  class: "yoy-switch",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleYearOverYear && _ctx.toggleYearOverYear(...args)))
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["radio-button", { active: _ctx.showYearOverYear }])
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["radio-dot", { active: _ctx.showYearOverYear }])
                    }, null, 2)
                  ], 2),
                  _hoisted_4
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("div", _hoisted_6, null, 512), [
                  [_vShow, _ctx.showImg]
                ]),
                (_ctx.showImg)
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      title: "点击下方表格内的指标名称行可切换查看该指标的历史趋势柱状图",
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_InfoCircleOutlined, {
                          class: "y-axis-tooltip-icon",
                          style: _normalizeStyle({ left: _ctx.getTooltipIconPosition() + 'px', top: '9px', zIndex: 1 })
                        }, null, 8, ["style"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.financialData.length > 0 && !_ctx.showImg)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_a_empty, {
                        class: _normalizeClass([_ctx.theme === 'dark' ? 'dark-empty' : 'light-empty']),
                        image: _ctx.simpleImage,
                        description: "当前指标暂无数据"
                      }, null, 8, ["class", "image"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.reportPeriods.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("table", _hoisted_10, [
                        _hoisted_11,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicators, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: 'indicator-' + index,
                              class: _normalizeClass({ 'active': _ctx.activeIndicator === item.key }),
                              onClick: ($event: any) => (_ctx.selectIndicator(item))
                            }, [
                              _createElementVNode("td", {
                                class: _normalizeClass(["indicator-cell", _ctx.getIndentClass(item.indent)]),
                                title: item.title
                              }, [
                                _createElementVNode("span", null, _toDisplayString(item.title), 1)
                              ], 10, _hoisted_13)
                            ], 10, _hoisted_12))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("table", _hoisted_15, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportPeriods, (period, index) => {
                              return (_openBlock(), _createElementBlock(_Fragment, {
                                key: 'period-' + index
                              }, [
                                _createElementVNode("th", null, _toDisplayString(_ctx.getReportDate(period.statementYear, period.reportType)), 1),
                                (_ctx.showYearOverYear)
                                  ? (_openBlock(), _createElementBlock("th", _hoisted_16, "同比"))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indicators, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: 'data-' + index,
                              class: _normalizeClass({ 'active': _ctx.activeIndicator === item.key }),
                              onClick: ($event: any) => (_ctx.selectIndicator(item))
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportPeriods, (period, pIndex) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: 'value-' + pIndex
                                }, [
                                  _createElementVNode("td", _hoisted_18, [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.formatValue(_ctx.getIndicatorValue(item.key, period))), 1)
                                  ]),
                                  (_ctx.showYearOverYear)
                                    ? (_openBlock(), _createElementBlock("td", {
                                        key: 0,
                                        class: _normalizeClass(["yoy-cell", _ctx.getYoyClass(item.key, period)])
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.formatYoy(_ctx.getYoyValue(item.key, period))), 1)
                                      ], 2))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 128))
                            ], 10, _hoisted_17))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_19, [
              _createVNode(_component_Nodata, {
                nodatadesc: _ctx.itemdata.title
              }, null, 8, ["nodatadesc"])
            ]))
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}